import Vue from 'vue';
/**
  Renders a toggle slider.

  Example usage from a parent component:

     <div class="field">
         <span>Label</span>
         <toggle-slider v-model="sentimentEnabled" />
     </div>

 */
export default Vue.extend({
    inheritAttrs: false,
    props: {
        value: { type: Boolean, required: false, default: false },
        small: { type: Boolean, required: false, default: false },
    }
});
